import { useEffect, useRef } from "react";
import { FaXmark } from "react-icons/fa6";

const Panel = ({ children, panelName, toggleAction, className }: { children: any; panelName: string; toggleAction: Function; className?: string }) => {
  const asideRef = useRef<HTMLElement>(null);
  useEffect(() => {
    function bindLinkClick(e: any) {
      e.preventDefault();
      const target = e.currentTarget;
      window.open(target.href, "_blank");
    }

    if (asideRef.current) {
      const aLinks = asideRef.current?.querySelectorAll("a");
      aLinks.forEach((l) => l.addEventListener("click", bindLinkClick));
    }

    return () => {
      const aLinks = asideRef.current?.querySelectorAll("a");

      aLinks?.forEach((l) => l.removeEventListener("click", bindLinkClick));
    };
  }, []);

  return (
    <aside ref={asideRef} className={`side-panel ${className} dark:bg-white text-neutral-gray-900 bg-neutral-gray-50 rounded-lg p-5 min-w-[350px] max-w-[350px] flex grow flex-col`}>
      <header className="flex text-xl justify-between mb-4">
        <h3 className="font-bold">{panelName}</h3>
        <button type="button" onClick={() => toggleAction()} className="text-neutral-gray-200">
          <FaXmark />
        </button>
      </header>
      <div className={`panel-content flex flex-col grow ${panelName === "Discador" && "overflow-y-auto gap-8"}`}>{children}</div>
    </aside>
  );
};

export default Panel;
